export default __webpack_public_path__ + "static/P_SearchThumb_IN-9008HD-6c54b7bc31bea3ad5a1181fc3cfff7e5.webp";